import { performPutRequest } from '@atlassian/jira-fetch';
import { isSynthetic } from '@atlassian/jira-project-create-importer-common';

type Props = {
	uploadUrl: string;
	file: File;
	signal: AbortSignal;
	contentType: string;
};

export const uploadFileToS3 = ({ uploadUrl, file, signal, contentType }: Props) =>
	performPutRequest(uploadUrl, {
		headers: {
			'Content-Type': contentType,
			'x-issynthetic-traffic': String(isSynthetic()),
		},
		body: file,
		signal,
	});
